import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store'

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(Element);

import elTableInfiniteScroll from 'el-table-infinite-scroll';
Vue.use(elTableInfiniteScroll);

//调用全局方法+api
import request from "@/utils/request"

Vue.prototype.$request = request
import api from "@/api"
Vue.prototype.$api  = api

import './assets/scss/index.scss'
// import './assets/scss/element-variables.scss'

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
